import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type {
  HeaderNavLinks,
  ServiceLink,
  ServiceLinksType,
} from "../../../common/Header/types";
import type { HeaderNavigationState } from "./types";

const initialState: HeaderNavigationState = {
  navLinks: [],
  visibleLinks: [],
};

export const headerNavigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    initializeVisibleLinks: (
      state,
      action: PayloadAction<ServiceLinksType>
    ) => {
      if (!action.payload) return;
      state.visibleLinks = action.payload.slice(0, 6);
    },

    setVisibleLinks: (state, action: PayloadAction<ServiceLinksType>) => {
      const limitedLinks = action.payload.slice(0, 6);
      state.visibleLinks = limitedLinks;
    },

    setNavLinks: (state, action: PayloadAction<HeaderNavLinks>) => {
      state.navLinks = action.payload;
    },

    addVisibleLink: (state, action: PayloadAction<ServiceLink>) => {
      if (
        state.visibleLinks.length >= 6 ||
        state.visibleLinks.includes(action.payload)
      )
        return;

      const newLinks = [...state.visibleLinks, action.payload];
      state.visibleLinks = newLinks;
    },

    removeVisibleLink: (state, action: PayloadAction<ServiceLink>) => {
      if (state.visibleLinks.length <= 1) return;

      const filtered = state.visibleLinks.filter((l) => l !== action.payload);
      state.visibleLinks = filtered;
    },

    reorderVisibleLinks: (
      state,
      action: PayloadAction<{ fromIndex: number; toIndex: number }>
    ) => {
      const { fromIndex, toIndex } = action.payload;
      if (
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= state.visibleLinks.length ||
        toIndex >= state.visibleLinks.length ||
        fromIndex === toIndex
      )
        return;

      const newLinks = [...state.visibleLinks];
      const [moved] = newLinks.splice(fromIndex, 1);
      newLinks.splice(toIndex, 0, moved);

      state.visibleLinks = newLinks;
    },
  },
});

export const headerNavigationReducers = headerNavigationSlice.reducer;
export const {
  initializeVisibleLinks,
  setNavLinks,
  setVisibleLinks,
  addVisibleLink,
  removeVisibleLink,
  reorderVisibleLinks,
} = headerNavigationSlice.actions;
